/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-is-valid jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';

import './NotifierCN.scss';

/**
 * @description NotifierCN
 *
 * @param {object} props - Component props
 *
 * @returns {<NotifierCN />}
 */
const NotifierCN = props => {
  const { text } = props.content;

  return (
    <div className="notifier-cn-message">
      <div className="tds-icon tds-icon-info-blue notifier-cn-icon" />
      <div className="notifier-cn-text">{text}</div>
    </div>
  );
};

NotifierCN.defaultProps = {
  content: {},
};

NotifierCN.propTypes = {
  content: PropTypes.objectOf(PropTypes.string),
};

export default NotifierCN;
